/**
 *  Check when the DOM is ready
 */
const dom_ready = callback => {

    return new Promise(resolve => {

        if (document.readyState !== 'loading') {
    
            callCallbackAndResolve();
    
        } else {
    
            document.addEventListener('DOMContentLoaded', callCallbackAndResolve);
    
        }

        function callCallbackAndResolve() {

            if (typeof callback === 'function') {

                callback();

            }

            resolve();

        }

    });

}

export default dom_ready;